module.exports = __webpack_public_path__ + "static/media/map-location.641bc092.svg";